// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"7a150612","745":"7a150612"}[chunkId] + ".chunk.css";
};